import {getColor} from "@/styles/ThemeConfig";
import styled from "@emotion/styled";
import {breakpoints} from "@/styles/sizes";
import CityTourCard from "@/components/city/cards/CityTourCard";
import HistoricalTourCard from "@/components/city/cards/HistoricalTourCard";

const ToursWrapper = styled.div`
    width: 100%;
    margin-top:40px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 30px;

    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns: 1fr;
    }
`;

export default function CityToursSection({title, subtitle, tours, historicalTour})
{
    return <div
        className={'container_small_with_padding_20'}
        style={{
            paddingTop:'120px',
        }}
    >
        <div style={{padding: '0 20px'}}>
            <h2 style={{
                textTransform: 'uppercase',
                fontSize: '26px',
                font: 'Josefin Sans',
                letterSpacing: '4px',
                color: getColor('gold'),
            }}>
                {title}
            </h2>
            <div style={{
                textTransform: 'uppercase',
                fontSize: '24px',
                font: 'Josefin Sans',
                fontWeight: 'bold',
                color: getColor('gold'),
            }}> {subtitle}</div>


            <ToursWrapper>
                {
                    tours?.map((item, index) => {
                        return <CityTourCard key={index} item={item}/>
                    })
                }

                {
                    historicalTour &&
                    <HistoricalTourCard
                        rating={historicalTour?.rating}
                        title={historicalTour?.title}
                        description={historicalTour?.description}
                        buttonText={historicalTour?.buttonText}
                        buttonLink={historicalTour?.buttonLink}
                        image={historicalTour?.image}
                    />
                }
            </ToursWrapper>
        </div>
    </div>
}
